import React from "react";

/**
 * Inline SVG icons for the Eva conversational survey page.
 * Exported from the Figma file "Conversational-AI-Survey".
 */

/** Circular AI sparkle used in the "AI SURVEY" badge and the "Generated by EVA" label. */
export function AiSparkIcon({ size = 11, color = "#501B6C" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.67065 2.7423C10.2101 3.55763 10.4986 4.5132 10.5006 5.49081C10.5027 6.46841 10.2181 7.42517 9.68201 8.24272C9.14597 9.06026 8.38203 9.70273 7.48468 10.0907C6.58732 10.4786 5.59594 10.5949 4.63315 10.4253M1.32965 8.2583C0.790249 7.44276 0.501803 6.48696 0.500008 5.50918C0.498214 4.5314 0.78315 3.57454 1.31956 2.75703C1.85597 1.93952 2.6203 1.29722 3.51798 0.909621C4.41566 0.522024 5.40729 0.406137 6.37015 0.576302"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.50015 7.0003C6.32858 7.0003 7.00015 6.32873 7.00015 5.5003C7.00015 4.67187 6.32858 4.0003 5.50015 4.0003C4.67173 4.0003 4.00015 4.67187 4.00015 5.5003C4.00015 6.32873 4.67173 7.0003 5.50015 7.0003Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00015 3.0003C9.55244 3.0003 10.0002 2.55259 10.0002 2.0003C10.0002 1.44802 9.55244 1.0003 9.00015 1.0003C8.44787 1.0003 8.00015 1.44802 8.00015 2.0003C8.00015 2.55259 8.44787 3.0003 9.00015 3.0003Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.00015 10.0003C2.55244 10.0003 3.00015 9.55259 3.00015 9.0003C3.00015 8.44802 2.55244 8.0003 2.00015 8.0003C1.44787 8.0003 1.00015 8.44802 1.00015 9.0003C1.00015 9.55259 1.44787 10.0003 2.00015 10.0003Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Twin sparkles shown inside Eva's gradient avatar. */
export function AvatarSparkleIcon({ width = 10, height = 15 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5.5 0C5.94898 3.92727 7.07143 5.56364 11 6C7.07143 6.43636 5.94898 8.07273 5.5 12C5.05102 8.07273 3.92857 6.43636 0 6C3.92857 5.56364 5.05102 3.92727 5.5 0Z"
        fill="white"
      />
      <path
        opacity="0.7"
        d="M12.5 11C12.7 12.9655 13.2 13.7931 15 14C13.2 14.2069 12.7 15.0345 12.5 17C12.3 15.0345 11.8 14.2069 10 14C11.8 13.7931 12.3 12.9655 12.5 11Z"
        fill="white"
      />
    </svg>
  );
}

/** Paper-plane icon for the send button. Inherits color via currentColor. */
export function SendIcon({ size = 17 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M7.73044 9.2687C7.59507 9.13358 7.43374 9.02726 7.25617 8.95617L1.63908 6.70367C1.57202 6.67676 1.51479 6.62997 1.47507 6.5696C1.43536 6.50922 1.41507 6.43815 1.41692 6.3659C1.41877 6.29366 1.44268 6.22372 1.48543 6.16545C1.52818 6.10719 1.58773 6.0634 1.65608 6.03996L15.1144 1.43579C15.1772 1.41312 15.2451 1.4088 15.3102 1.42332C15.3754 1.43784 15.435 1.47061 15.4822 1.5178C15.5294 1.56499 15.5622 1.62464 15.5767 1.68977C15.5912 1.7549 15.5869 1.82282 15.5642 1.88558L10.96 15.3439C10.9366 15.4123 10.8928 15.4718 10.8345 15.5146C10.7763 15.5573 10.7063 15.5812 10.6341 15.5831C10.5619 15.5849 10.4908 15.5646 10.4304 15.5249C10.37 15.4852 10.3232 15.428 10.2963 15.3609L8.04383 9.74242C7.97242 9.56498 7.86581 9.40383 7.73044 9.2687ZM7.73044 9.2687L15.4799 1.52079"
        stroke="currentColor"
        strokeWidth="1.41667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Check mark shown in the "Survey Complete!" card. */
export function CheckIcon({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M23.3333 7L10.5 19.8333L4.66667 14"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
